import { Component, HostListener, Input, OnInit, ViewChild } from "@angular/core";
import {
  isUndefined,
  onlyAphaNumeric,
  spaceToHyphen,
  stringToNumber,
} from "src/app/services/codeUtils";
import { ConfigService } from "src/app/services/config/config.service";
import { EventsService } from "src/app/services/event/event.service";
import { GameHubControllerService } from "src/app/services/gameHub/game-hub-controller";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { WebcontentService } from "src/app/services/webcontent/webcontent.service";
import { Navigator } from "../../menu/navigator";
import { GamesService } from "src/app/services/lobby/games.service";
import { ScrollService } from "src/app/services/scroll/scroll.service";
import { LobbyStateService } from "src/app/services/lobbyState/lobby-state.service";
import { LobbyService } from "src/app/services/lobby/lobby.service";
import { LobbyNavigator } from 'src/app/services/lobby/lobby-navigator.service';
import { AppLinksService } from "src/app/services/applinks/app-links.service";
import { IonInfiniteScroll } from "@ionic/angular";

@Component({
  selector: "app-gallery-casino",
  templateUrl: "./gallery-casino.component.html",
  styleUrls: ["./gallery-casino.component.scss"],
})
export class GalleryCasinoComponent implements OnInit {
  public isAuthenticated: boolean;
  public isDemoEnabled: boolean;
  public pageSizeSet = 25;
  public mobileGamesSize = 20;
  public pageSize: number = this.pageSizeSet;
  // "https://sdtest-cdn.palainteractive.com/assets/social/games/";
  public imagesPath: string;
  public isfavourite = false;
  public filteredCasinoGames: Array<any> = [];
  public mobileCasinoGames: any = null;
  public selectedItem: string;
  public allGamesLoaded = false;
  public mobileGameCounter = 1;
  public showInfo: boolean;
  public isTop: boolean = this.config.getConfig().FEATURE_JACKPOT_POSITION_TOP == "1" ? true : false;

  @Input() showLastPlayed: boolean;
  @Input() customerLevel: number;
  @Input() isMobileWeb: boolean;
  @Input() LastPlayedGamesPresent: boolean;
  @Input() isMobileApp: boolean;

  infiniteScrollThreshold: string = '15%'; // Default threshold
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  nextBatchSize: number;


  constructor(
    public webcontentService: WebcontentService,
    private config: ConfigService,
    private userSessionService: UserSessionService,
    private eventsService: EventsService,
    private gameHubControllerService: GameHubControllerService,
    private navigator: Navigator,
    private gamesService: GamesService,
    private lobbyNavigator: LobbyNavigator,
    private applinkService: AppLinksService,
    private lobbyStateService: LobbyStateService,
    private scroll: ScrollService,
    private readonly lobbyService: LobbyService // GameHubControllerService yet to be implmented
  ) { }


  // Adjust the page size and infinite scroll threshold dynamically
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.adjustPageSizeAndThreshold();
    this.autoLoadAllBatches();
  }


  ngOnInit() {
    this.nextBatchSize = stringToNumber(this.config.getConfig().FEATURE_LOBBY_NEXT_BATCH_SIZE) || 20;
    this.showInfo = this.config.getConfig().FEATURE_ENABLE_GAMEINFO == "1" ? true : false;
    this.imagesPath = this.lobbyService.galleryImagePath;
    this.configReload();
    this.userSessionService
      .getCustomerSubscription()
      .then((subscription) => this.subscribeToCustomer(subscription));
    this.updateAuthentication();

    this.lobbyStateService.getCurrentKeywordSubject().subscribe((data) => {
      this.filteredCasinoGames = data.gamesInfo;
      this.selectedItem = data.keyword;
      if(this.filteredCasinoGames?.length){
        this.autoLoadAllBatches(); // Automatically load more after first batch
      }
      if (this.isMobileApp && this.filteredCasinoGames) {
        this.mobileGameCounter = 1;
        this.allGamesLoaded = false;
        this.mobileCasinoGames = this.filteredCasinoGames.slice(
          0,
          this.mobileGamesSize
        );
      }
    });
    if (this.isMobileApp) {
      this.scroll.getScrollPosition().subscribe((element) => {
        if (element.detail.scrollTop > 300 * this.mobileGameCounter && !this.allGamesLoaded) {
          this.updateMobileCasinoGames();
          this.mobileGameCounter++;
        }
      });
    }
  }

  adjustPageSizeAndThreshold() {


    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    if (screenWidth < 768 && screenHeight < 1024) {
      // For small screens like phones in portrait mode
      this.pageSize = 16;
      this.infiniteScrollThreshold = '40%';
    } else if (screenWidth < 1024 && screenHeight < 1366) {
      // For tablets or phones in landscape mode
      this.pageSize = 20;
      this.infiniteScrollThreshold = '50%';
    } else if (screenWidth >= 1024 && screenHeight >= 1366) {
      // For larger screens, e.g., laptops/desktops
      this.pageSize = 30;
      this.infiniteScrollThreshold = '50%';
    } else {
      // Fallback for other device sizes or orientations
      this.pageSize = 24;
      this.infiniteScrollThreshold = '35%';
    }
  }

  // Automatically load all batches till the end of the list
  autoLoadAllBatches() {
    this.adjustPageSizeAndThreshold();
    const loadNextBatch = () => {
      if (this.pageSize < this.filteredCasinoGames.length) {
        // Programmatically trigger infinite scroll to load next batch
        this.doInfinite({ target: this.infiniteScroll }).then(() => {
          loadNextBatch(); // Load next batch after current one is complete
        });
      }
    };

    loadNextBatch(); // Start loading batches
  }


  configReload() {
    this.eventsService.subscribe("event:config:reload", () => {
      this.config.isLoaded().then(() => {
        setTimeout(() => {
          this.showInfo = this.config.getConfig().FEATURE_ENABLE_GAMEINFO == "1" ? true : false;
          this.imagesPath = this.lobbyService.galleryImagePath;
        }, 500);
      })
    });
  }

  subscribeToCustomer(subscription) {
    subscription.subscribe(() => {
      this.updateAuthentication();
      let demoModeEnabled = false; //this.config.getConfig()["DEMO_MODE_ENABLED"] == "1" ? true : false;
      let demoLoggedOutEnabled = false; //this.config.getConfig()["DEMO_LOGOUT_ENABLED"] == "1" ? true : false;

      //if the master switch DEMO_MODE_ENABLED is false turn all demo mode off
      if (!demoModeEnabled) {
        this.isDemoEnabled = false;
      }
      //if the DEMO_LOGOUT_ENABLED is false that means the player cant play demo mode while logged out. So next we check if the player is logged out and if so turn off demo mode
      else if (!demoLoggedOutEnabled && !this.isAuthenticated) {
        this.isDemoEnabled = false;
      }
      //otherwise demo is on son!
      else {
        this.isDemoEnabled = true;
      }
    });
  }

  updateAuthentication() {
    this.userSessionService.isAuthenticated().then((isAuthenticated) => {
      this.isAuthenticated = isAuthenticated;
    });
  }

  doInfinite(e) {
    return new Promise<void>((resolve) => {
      setTimeout(() => {
        const nextBatchSize = this.pageSize + this.nextBatchSize;
        this.pageSize = Math.min(nextBatchSize, this.filteredCasinoGames.length);
        // If event is defined, call the complete function
        if (e && e.target && typeof e.target.complete === 'function') {
          e.target.complete(); // Complete the infinite scroll action
        }

        // Disable the infinite scroll if all games are loaded
        if (this.pageSize >= this.filteredCasinoGames.length) {
          if (e && e.target && typeof e.target.complete === 'function') {
            e.target.disabled = true;
          }
        }
        resolve();
      }, 0); // Simulate async loading
    });
  }
  increasePageSize() {
    this.pageSize = this.pageSize + this.pageSizeSet;
  }

  launchCasinoGame(gameData) {
    if (!this.isAuthenticated) {
      // save the gameData for later launch
      //this.LobbyService.setWaitingGameData(gameData);
      return this.openLoginModal(gameData);
    }

    return this.gameHubControllerService.launchCasinoGame(gameData);
  }

  public showAlreadyLoggedInAlert(): any {
		const popoverComp = 'PopoverAlertComponent';

		let data: any = {
			content: "You are already logged into a Mohegan PA Casino Account.",
		};

		return this.navigator.openPopover(popoverComp, data);
	}

  launchExternalLink(data) {
    const externalLink = data.externalLink;
    // console.log("externalLink", externalLink)
    if (externalLink?.url) {
      const url = externalLink?.url
      if (externalLink.isExternalUrl) {
        this.applinkService.openExternalPage(url);
      } else {
        if (externalLink.label === "action_links") {
          if (this.isAuthenticated) {
            if (url !== "SignupStepOneComponent") {
              this.navigator.navigateTo(url, {multipleModals: true})
            } else {
              this.showAlreadyLoggedInAlert();
            }
          } else {
            this.lobbyService.setWaitingDialogPage(url);
            return this.navigator.navigateTo("LoginComponent")
          }
        } else {
          this.webcontentService.updateExternalLink(url);
          this.navigator.toTab("c", false, url);
        }
      }
      return
    }
  }

  launchCasinoGameDemo(gameData) {
    // this.gameHubControllerService.launchCasinoGameDemo(gameData);
  }

  openLoginModal(gameData) {
    if (gameData.super_type === "LIVE_DEALER") {
      localStorage.setItem('skipActiveBonusCheck', 'true');
      this.lobbyNavigator.toKeyTab('Live dealer');
    }
    this.lobbyService.setWaitingGameData(gameData);
    return this.navigator.navigateTo("LoginComponent");
  }

  public onInfo(gamedata: any) {
    this.navigator.navigateTo('GameDetailsComponent', {}, {gamedata});
    // let wpLink: string = this.getWPPageStub(gamedata.game_name);
    // const matchedLink: any = this.checkForExternalLinks(wpLink);
    // this.updateWpContent(matchedLink, wpLink);
    // this.navigator.toWebview();
    // this.lobbyService.setWaitingGameData(gamedata);
    // return setTimeout(
    //   () => this.navigator.pushHistoryState("game/" + wpLink),
    //   1000
    // );
  }

  public checkForExternalLinks(url: string): any {
    const externalLinks = this.config.getExternalLinks().payload;
    const filteredExternalLink = externalLinks.filter(
      (link) => link.url == url
    )[0];
    return filteredExternalLink;
  }

  public getWPPageStub(name: string): string {
    const onlyAlphaNumeric = onlyAphaNumeric(name);
    const lowerCaseName = onlyAlphaNumeric.toLowerCase();
    const urlStub = spaceToHyphen(lowerCaseName);
    return urlStub;
  }

  public updateWpContent(link: any, page: string): any {
    const gameInfoErrorPage = this.config.getConfig().WP_GAME_INFO_ERROR_PAGE ?? "gameinfo_default";
    if (isUndefined(link) && !link) return this.webcontentService.updateExternalLink(gameInfoErrorPage);
    return this.webcontentService.updateExternalLink(page);
  }

  isFavourite(game_id) {
    if (!this.isAuthenticated) return false;
    return this.gamesService.isFavourite(game_id);
  }

  updateMobileCasinoGames() {
    if (!this.filteredCasinoGames) return;
    if (this.mobileCasinoGames.length < this.filteredCasinoGames.length) {
      this.mobileGamesSize = this.mobileGamesSize + 20;
      this.mobileCasinoGames = this.filteredCasinoGames.slice(
        0,
        this.mobileGamesSize
      );
    } else {
      this.mobileGamesSize = 20;
      this.allGamesLoaded = true;
    }
  }

  makeFavourite(gamedata) {
    if (!this.isAuthenticated) {
      this.navigator.navigateTo("LoginComponent");
      return;
    }

    this.gamesService.addFavouritesAndRecreate(gamedata);
    return;
  }

  makeUnFavourite(game_id) {
    if (!this.isAuthenticated) {
      this.navigator.navigateTo("LoginComponent");
      return;
    }

    this.gamesService.removeFavouritesAndRecreate(game_id);

    return;
  }

  getContentFromJSON(json) {
    if (!json) return;
    return JSON.parse(json);
  }
}
